import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import UnauthorizedLayout from '../UnauthorizedLayout'

const ActivateAccount = () => {
  const { t } = useTranslation('auth')
  const navigate = useNavigate()

  return (
    <UnauthorizedLayout>
      <div className="w-[75%] desktop:w-[500px] flex flex-col justify-center items-center gap-3">
        <h2 className="text-center text-4xl font-semibold">
          {t('activate.title')}
        </h2>
        <p className="text-center leading-6 font-light text-white text-opacity-70">
          {t('activate.description')}
        </p>
        <button
          className="h-[40px] mt-3 w-full bg-blue text-white rounded-xl hover:bg-blue-hover transition duration-100 active:shadow-[inset_0px_0px_14px_5px_#00000020] flex justify-center items-center"
          onClick={() => navigate('/login')}
        >
          {t('activate.button.done')}
        </button>
      </div>
    </UnauthorizedLayout>
  )
}

export default ActivateAccount
